export default "__VITE_ASSET__5cf44809__"